export default __webpack_public_path__ + "static/media/cam.b3564d4e.svg";